import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import {
  getTextForFeedback,
  setMainPageLangAction,
} from 'store/actions/feedback';
import { getText } from 'services/languageService';
import { MainLangType, PersonalDataModalProps } from 'types/mainPage';
import { langs } from 'components/FeedbackModal/constants';
import CloseIcon from '@mui/icons-material/Close';
import { Box, ButtonGroup, IconButton, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export const PersonalDataModal: React.FC<PersonalDataModalProps> = ({
  fs,
  handleClose,
}) => {
  const {
    isOpenInfoModal: open,
    infoLang,
    feedbackText,
  } = useAppSelector((state) => state.feedback);
  const { lang } = useAppSelector((state) => state.mainPage);
  const dispatch = useAppDispatch();

  const onChangeLang = (lang: MainLangType) => {
    dispatch(setMainPageLangAction(lang));
  };
  useEffect(() => {
    if (lang !== infoLang) {
      onChangeLang(lang);
    }
  }, []);

  useEffect(() => {
    dispatch(getTextForFeedback(infoLang));
  }, [infoLang]);

  return (
    <Dialog fullScreen={fs} open={open} onClose={handleClose}>
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: 2,
        }}
      >
        <Typography
          sx={{
            pl: 1,
          }}
        >
          {getText('FEEDBACK_INFO_TITLE')}
        </Typography>
        <IconButton
          edge="start"
          color="inherit"
          onClick={handleClose}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          sx={{ maxHeight: fs ? '75vh' : '350px', overflow: 'auto' }}
        >
          {feedbackText}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'center',
          p: 1,
          pb: 2,
          mb: 2,
        }}
      >
        <Box
          sx={{
            backgroundColor: (theme) => theme.palette.custom.transparentWhite,
            mr: '2px',
            mt: '1px',
            alignSelf: 'baseline',
          }}
        >
          <ButtonGroup variant="text">
            {langs.map((item) => {
              return (
                <Button
                  key={item.value}
                  sx={{
                    color: (theme) =>
                      infoLang === item.value
                        ? theme.palette.primary.main
                        : theme.palette.grey[600],
                  }}
                  onClick={() => {
                    onChangeLang(item.value);
                  }}
                >
                  {item.lang}
                </Button>
              );
            })}
          </ButtonGroup>
        </Box>
        <Button autoFocus onClick={handleClose} variant="outlined">
          OK
        </Button>
        <Box sx={{ width: '120px', height: '30px' }} />
      </DialogActions>
    </Dialog>
  );
};
